import React, { useEffect } from "react";
import { Loading } from "../common/Loading";
import { useInformationApiResult } from "../../hooks/information/useInformationApiResult";
import { useSendLocationToGtag } from "../../hooks/common/useSendLocationToGtag";
import { AdminInformationAddButton } from "./components/AdminInformationAddButton";
import { InformationListProvider } from "../../provider/InformationListProvider";
import { InformationListPager } from "./components/InformationListPager";
import { InformationList } from "./components/InformationList";

export function InformationListPage() {
    useSendLocationToGtag("お知らせ一覧");

    const [processing, registerHasCorrect, registerHasError, deleteHasCorrect, deleteHasError] = useInformationApiResult();

    // 更新時画面スクロールをトップにする
    useEffect(() => {
        window.scroll(0, 0);
    }, [registerHasCorrect, registerHasError, deleteHasCorrect, deleteHasError]);

    // レスポンス取得中
    if (processing > 0) return <Loading />;

    return (
        <InformationListProvider>
            <div className={"information_list_page"}>
                <div className={"container"}>
                    <h1 className={"page_title"}>お知らせ</h1>
                    <AdminInformationAddButton />
                    <InformationList />
                    <InformationListPager />
                </div>
            </div>
        </InformationListProvider>
    );
}